import { render, staticRenderFns } from "./CourseGrades.vue?vue&type=template&id=d057dac8&"
import script from "./CourseGrades.vue?vue&type=script&lang=ts&"
export * from "./CourseGrades.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports